import { formatDate, formatDateISO } from '@helpers/date';
import * as React from 'react';
import S from './ArticleDate.styles';
export var ArticleDateVariant;
(function (ArticleDateVariant) {
    ArticleDateVariant["Black"] = "black";
    ArticleDateVariant["Green"] = "green";
    ArticleDateVariant["White"] = "white";
})(ArticleDateVariant || (ArticleDateVariant = {}));
export var ArticleDateSize;
(function (ArticleDateSize) {
    ArticleDateSize["Large"] = "large";
    ArticleDateSize["Small"] = "small";
})(ArticleDateSize || (ArticleDateSize = {}));
const ArticleDate = ({ date, tags, size, variant }) => {
    return (React.createElement(S.Container, { "data-size": size, "data-variant": variant },
        React.createElement(S.Date, { dateTime: formatDateISO(date) }, formatDate(date, 'MMM dd, yyyy')),
        " | ",
        tags));
};
export default ArticleDate;
